export default "./dist/stdassets/images/icons/legend-map.png";